import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import clsx from "clsx";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { DelayInput } from "react-delay-input";
import KeyboardEventHandler from "react-keyboard-event-handler";
import Time from "react-time";
import { windowsColorToHex } from "../../utils/colors";
import ChartingInfo from "../ChartingInfo";
import CreateBanner from "../CreateBanner";
import CreateGame from "../CreateGame";
import DeleteGame from "../DeleteGame";
import GameModify from "../GameModify";
import GameStatus from "../GameStatus";
import ModifyBanner from "../ModifyBanner";
import EventsPerLeagueList from "../events/eventsPerLeagueList";
import GamePeriods from "../games/gameComponents/GamePeriod";
import GameSettingsByLt from "../games/gameComponents/GameSettingsByLt";
import HideGames from "../games/gameComponents/HideGames";
import "./Schedule.css";
import { updateMLxp } from "./ScheduleHelper";
import { updateSPxp } from "./ScheduleHelperSpread";
import { updateTOxp } from "./ScheduleHelperTotal";
import { updateSpecialXp } from "./ScheduleHelperSpecial";
import { updateDrawXp } from "./ScheduleHelperDraw";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  table: {
    borderRadius: 10,
    overflow: "hidden",
  },
  tableHead: {
    backgroundColor: "#f8f9fb",
  },
  columnHeader: {
    backgroundColor: "#f8f9fb",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "#6b7280",
  },
}));
const useStylesCheck = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxSizing: "border-box",
    position: "relative",
    border: "1.5px solid rgba(0,0,0,0.28)",
    backgroundColor: "white",
    boxShadow: "none",
    "$root.Mui-focusVisible &": {
      outline: "1px auto rgba(99,102,241,.6)",
      outlineOffset: 1,
    },
    "input:hover ~ &": {
      borderColor: "#6366f1",
    },
    "input:disabled ~ &": {
      border: "1.5px solid rgba(0,0,0,0.12)",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    borderColor: "#6366f1",
    backgroundColor: "white",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 7,
      height: 7,
      borderRadius: "50%",
      backgroundColor: "#6366f1",
    },
    "input:hover ~ &": {
      borderColor: "#4f46e5",
    },
  },
});
export default function Schedule(props) {
  const classes = useStyles();
  const classCheck = useStylesCheck();

  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  var time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  var dateTime = date + " " + time;

  const [selectedIdGame, setselectedIdGame] = useState();
  const [rotation, setRotation] = useState();
  const [selectedPlay, setselectedPlay] = useState();
  const [points, setPoints] = useState();
  const [selectedIdLeague, setselectedIdLeague] = useState();
  const [selectedLeagueName, setSelectedLeagueName] = useState("");
  const [isModify, setIsModify] = useState(false);
  const [isModifyBanner, setIsModifyBanner] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isPeriod, setIsPeriod] = useState(false);
  const [isEvent, setIsEvent] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isCharting, setIsCharting] = useState(false);
  const [isStatus, setIsStatus] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [newBanner, setNewBanner] = useState(false);
  const [parentGame, setParentGame] = useState();
  const [homeNumber, setHomeNumber] = useState();
  const [visitorNumber, setVisitorNumber] = useState();
  const [homeTeam, setHomeTeam] = useState();
  const [visitorTeam, setVisitorTeam] = useState();
  const [gameDateTime, setGameDateTime] = useState();
  const [recentUpdatedGame, setRecentUpdatedGame] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [currentPage, setCurrentPage] = useState(0);
  const [valueHasChanged, setValueHasChanged] = useState(1);
  const [isChecked, setisChecked] = useState(false);

  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const [localValues, setLocalValues] = useState({});
  const rowRefs = useRef({});
  const [recentUpdatedRow, setRecentUpdatedRow] = useState(null);
  const [highlightRow, setHighlightRow] = useState(null);
  const [lineHistoryModal, setLineHistoryModal] = useState(false);
  const [linesHistoryVisitor, setLinesHistoryVisitor] = useState([]);
  const [linesHistoryHome, setLinesHistoryHome] = useState([]);
  const [rowSelected, setRowSelected] = useState({});
  const [isDraw,setIsDraw] = useState(false);


  async function GetLinesHistoryVisitor(row, play, teamNumber) {
    setLinesHistoryVisitor([]);
    const requestDto = {
      prmIdGame: row.idGame,
      prmIdLineType: props.IdLinetype,
      prmIdSport: props.IdSport,
      prmTeamNumber: teamNumber,
      prmPlay: play,
      prmColumnNumber: 0
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API2_URL + "/game/SystemChangedLines_GetChanges",
        requestDto
      );
      console.log("Datos recibidos:", response.data);
      setLinesHistoryVisitor(response.data);
      setRowSelected(row);
      console.log(row)
    } catch (error) {
      console.error("Error al obtener cambios de líneas:", error);
    }
  }

    async function GetLinesHistoryHome(row, play, teamNumber) {
    setLinesHistoryHome([]);
    const requestDto = {
      prmIdGame: row.idGame,      
      prmIdLineType: props.IdLinetype,        
      prmIdSport: props.IdSport,       
      prmTeamNumber: teamNumber,    
      prmPlay: play,          
      prmColumnNumber: 0    
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API2_URL + "/game/SystemChangedLines_GetChanges",
        requestDto
      );
      console.log("Datos recibidos:", response.data);
      setLinesHistoryHome(response.data);
      setRowSelected(row);
      setLineHistoryModal(true);
      setIsDraw(false);
    } catch (error) {
      console.error("Error al obtener cambios de líneas:", error);
    }
  }

  
const TOL_MS = 100;

const mergedRows = React.useMemo(() => {
  const v = (linesHistoryVisitor ?? [])
    .map(x => ({ ...x, ts: new Date(x.PlacedDate).getTime() }))
    .sort((a, b) => a.ts - b.ts);
  const h = (linesHistoryHome ?? [])
    .map(x => ({ ...x, ts: new Date(x.PlacedDate).getTime() }))
    .sort((a, b) => a.ts - b.ts);

  const out = [];
  let i = 0, j = 0;

  while (i < v.length || j < h.length) {
    const vi = v[i];
    const hi = h[j];

    if (vi && hi) {
      const diff = Math.abs(vi.ts - hi.ts);
      if (diff <= TOL_MS) {

        out.push({
          time: new Date(Math.min(vi.ts, hi.ts)),
          visitor: vi.ChangeValue ?? "",
          home: hi.ChangeValue ?? "",
        });
        i++; j++;
        continue;
      }
     
      if (vi.ts < hi.ts) {
        out.push({ time: new Date(vi.ts), visitor: vi.ChangeValue ?? "", home: "" });
        i++;
      } else {
        out.push({ time: new Date(hi.ts), visitor: "", home: hi.ChangeValue ?? "" });
        j++;
      }
      continue;
    }

    if (vi) { out.push({ time: new Date(vi.ts), visitor: vi.ChangeValue ?? "", home: "" }); i++; }
    if (hi) { out.push({ time: new Date(hi.ts), visitor: "", home: hi.ChangeValue ?? "" }); j++; }
  }


  return out.sort((a, b) => b.time - a.time);
}, [linesHistoryVisitor, linesHistoryHome]);

const fmt = d => d?.toLocaleString(undefined, { hour12: true }) ?? "";

  const handleInputChange = (rowId, field, value) => {
    setLocalValues((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [field]: value,
      },
    }));
  };

  const [inputsChanged, setInputsChanged] = useState({});
  const [spreadsChanged, setSpreadsChanged] = useState({});

  function getShortValue(code) {
    switch(code) {
      case 'O':
        return 'OP';
      case 'D':
        return 'OB';
      case 'C':
        return 'CA';
      case 'F':
        return 'FN';
      default:
        return '';
    }
  }

  const sportsOrder = {
    stm: ["CBB", "CFB", "NBA", "NFL"], 
    mts: ["MLB", "NHL", "SOC", "MU", "ESOC"]  
  };

  const columnOrderBySport = {
    stm: ["Spread", "Totals", "ML"],
    mts: ["ML", "Totals", "Spread"],
    default: ["Spread", "Totals", "ML"]
  };

  const getOrderForSport = (sportId) => {
    const trimmedSportId = sportId.trim();
    
    if (sportsOrder.stm.includes(trimmedSportId)) {
      return columnOrderBySport.stm;
    } else if (sportsOrder.mts.includes(trimmedSportId)) {
      return columnOrderBySport.mts;
    } else {
      return columnOrderBySport.default;
    }
  };

  const renderTableHead = (sportId) => {
    const columnOrder = getOrderForSport(sportId);
    // console.log(columnOrder)
    // console.log(sportId)
    return (
      <TableHead className={`${classes.tableHead} sticky top-0 z-50`}>
        <TableRow>
          <TableCell className={classes.columnHeader}>
            <strong>Date</strong>
          </TableCell>
          <TableCell className={classes.columnHeader}>
            <strong>Rotation</strong>
          </TableCell>
          <TableCell className={classes.columnHeader}>
            <strong>Match</strong>
          </TableCell>

          {columnOrder && columnOrder.map((column) => (
            <React.Fragment key={column}>
              <TableCell className={classes.columnHeader}>
                <strong>{column}</strong>
              </TableCell>
              <TableCell className={classes.columnHeader}>
                <strong>Action</strong>
              </TableCell>
              <TableCell className={classes.columnHeader}>
                <strong>Sum</strong>
              </TableCell>
            </React.Fragment>
          ))}

          <TableCell className={classes.columnHeader}>

          </TableCell>
        </TableRow>
      </TableHead>
    );
  };
  

  /*const setEventKey = function (key, e) {
    if (key === "alt+d") {
      if (isChecked) {
        setIsDelete(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+i") {
      if (isChecked) {
        setIsPeriod(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+m") {
      if (isChecked) {
        setIsModify(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+b") {
      if (isChecked) {
        setNewBanner(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+t") {
      if (isChecked) {
        setIsSettings(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+n") {
      setIsNew(true);
    } else if (key === "alt+s") {
      if (isChecked) {
        setIsStatus(true);
      } else {
        alert("You must select a game");
      }
    }
    else if (key === "ctrl+g") {
      SendToGrade();
    } 
  };*/

   useEffect(() => {
      setCurrentPage(0);
    }, [props.IdSport]);

  const setEventKey = function (key, e) {
    const actionsWithCheck = {
      "alt+d": () => setIsDelete(true),
      "alt+i": () => setIsPeriod(true),
      "alt+m": () => setIsModify(true),
      "alt+b": () => setNewBanner(true),
      "alt+t": () => setIsSettings(true),
      "alt+s": () => setIsStatus(true),
    };

    const actionsWithoutCheck = {
      "alt+n": () => setIsNew(true),
      // "ctrl+g": () => SendToGrade(e),
    };

    if (actionsWithCheck[key]) {
      if (isChecked) {
        actionsWithCheck[key]();
      } else {
        alert("You must select a game");
      }
    } else if (actionsWithoutCheck[key]) {
      actionsWithoutCheck[key]();
    }
  };

  const updateML = (
    idGame,
    odds,
    idLinetype,
    newValue, //linea
    idSport,
    teamNumber,
    play,
    column,
    changeLine,
    changeOdds,
    otherTeam,
    IdGameType,
    otherColumn,
    otherPlay,
    idLeague
  ) => {
    setRecentUpdatedRow(idGame);
    console.log('props1=====>', props)
    updateMLxp(
      idGame,
      odds,
      idLinetype,
      newValue, //linea
      idSport,
      teamNumber,
      play,
      column,
      changeLine,
      changeOdds,
      otherTeam,
      IdGameType,
      otherColumn,
      otherPlay,
      valueHasChanged,
      setRecentUpdatedGame,
      setValueHasChanged,
      props, 
      idLeague
    );
  };

  const updateDraw = (
    idGame,
    odds,
    idLinetype,
    newValue, //linea
    idSport,
    teamNumber,
    play,
    column,
    changeLine,
    changeOdds,
    otherTeam,
    IdGameType,
    otherColumn,
    otherPlay,
    idLeague
  ) => {
    setRecentUpdatedRow(idGame);
    console.log('props2=====>', props)
    updateDrawXp(
      idGame,
      odds,
      idLinetype,
      newValue, //linea
      idSport,
      teamNumber,
      play,
      column,
      changeLine,
      changeOdds,
      otherTeam,
      IdGameType,
      otherColumn,
      otherPlay,
      valueHasChanged,
      setRecentUpdatedGame,
      setValueHasChanged,
      props,
      idLeague
    );
  };

  const isGameDateTimePassed = (gameDateTime) => {
    const now = new Date();
    const gameDate = new Date(gameDateTime);
    const nowEastern = toEasternTime(now);
    // console.log(now > gameDate)
    // console.log("NOW___ ", now)
    // console.log("NOWEASTERN___ ", nowEastern)
    // console.log("GAME___", gameDate)
    return !(nowEastern < gameDate);
  };

  function toEasternTime(date) {
    const options = { timeZone: "America/New_York", hour12: false };
    const formatter = new Intl.DateTimeFormat("en-US", {
      ...options,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  
    const [
      month, day, year, hour, minute, second,
    ] = formatter
      .formatToParts(date)
      .filter(part => part.type !== "literal")
      .map(part => part.value);
  
    return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
  }

  const updateSP = async (
    idGame,
    odds,
    idLinetype,
    newValue, //linea
    idSport,
    teamNumber,
    play,
    column,
    changeLine,
    changeOdds,
    otherTeam,
    IdGameType,
    otherColumn,
    otherPlay,
    isOdd // 1  is just the spread, 2 is spread odd
  ) => {
    setRecentUpdatedRow(idGame);
    try{
      if(props.IdSport.trim() === "NHL"){
        await updateSpecialXp(
          idGame,
          odds,
          idLinetype,
          newValue, // linea
          idSport,
          teamNumber,
          play ,
          column,
          changeLine,
          changeOdds,
          otherTeam,
          IdGameType,
          otherColumn,
          otherPlay == 0 ? 7 : 8,
          isOdd, // 1  is just the spread, 2 is spread odd
          valueHasChanged,
          setRecentUpdatedGame,
          setValueHasChanged,
          props,
        );
      }else{
        await updateSPxp(
          idGame,
          odds,
          idLinetype,
          newValue, // linea
          idSport,
          teamNumber,
          play,
          column,
          changeLine,
          changeOdds,
          otherTeam,
          IdGameType,
          otherColumn,
          otherPlay,
          isOdd, // 1  is just the spread, 2 is spread odd
          valueHasChanged,
          setRecentUpdatedGame,
          setValueHasChanged,
          props,
        );
      }
    } finally{
      setLocalValues({});
      // setTimeout(()=>{
      //   rowRefs.current[idGame]?.scrollIntoView({ behavior: "smooth", block: "center" });
      // },4000)
    }
  };

  useEffect(() => {
    if (recentUpdatedRow && rowRefs.current[recentUpdatedRow]) {
      rowRefs.current[recentUpdatedRow]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      setHighlightRow(recentUpdatedRow);

      const timer = setTimeout(() => {
        setHighlightRow(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [props.data]);

  const scrollRow = (id)=>{
    rowRefs.current[id]?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  const updateTO = async (
    idGame,
    odds,
    idLinetype,
    newValue, //linea
    idSport,
    teamNumber,
    play,
    column,
    changeLine,
    changeOdds,
    otherTeam,
    IdGameType,
    otherColumn,
    otherPlay,
    isOdd
  ) => {
    setRecentUpdatedRow(idGame);
    try{
      await updateTOxp(
        idGame,
        odds,
        idLinetype,
        newValue, // linea
        idSport,
        teamNumber,
        play,
        column,
        changeLine,
        changeOdds,
        otherTeam,
        IdGameType,
        otherColumn,
        otherPlay,
        isOdd, // 1  is just the spread, 2 is spread odd
        valueHasChanged,
        setRecentUpdatedGame,
        setValueHasChanged,
        props
      );
    }finally{
      setLocalValues({});
      setInputsChanged((prev) => ({
        ...prev,
        [idGame]: { firstChanged: false, secondChanged: false }
      }));
    }
  };

  useEffect(()=>{
    resetDatesRow();
  },[props.data])

  useEffect(() => setRecentUpdatedGame(props.getRecentGame()));

  useEffect(() => {
    if (props.selectedGame.length > 0) {
      setisChecked(true);
    } else {
      setisChecked(false);
    }
  });

  const handleCloseModify = function () {
    setIsModify(false);
  };

  const handleCloseEvent = function () {
    setIsEvent(false);
  };
  const handleCloseBannerModify = function () {
    setIsModifyBanner(false);
  };
  const handleCloseCharting = function () {
    setIsCharting(false);
  };
  const handleCloseHideGames = function () {
    setIsHidden(false);
  };
  const handleCloseStatus = function () {
    setIsStatus(false);
  };
  const handleCloseCreate = function () {
    setIsNew(false);
  };
  const handleDelete = function () {
    setIsDelete(false);
  };
  const handlePeriods = function () {
    setIsPeriod(false);
  };
  const handleSettings = function () {
    setIsSettings(false);
  };
  const handleCloseNewBanner = function () {
    setNewBanner(false);
  };
  const pageNumbers = [];
  if (props.data) {
    for (let i = 1; i <= Math.ceil(props.data.length); i++) {
      pageNumbers.push(i);
    }
  }
  function handleClick(event, newPage) {
    setCurrentPage(newPage);
  }
  const handleChange = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(0);
  };

  const getStyle = (gameStat, gameDateTime) => {
    let style = "";

    let dateToday = new Date(dateTime);
    let dateGame = new Date(gameDateTime.date);
    if (gameStat == "D") {
      style = "schedule-closed";
    } else if (dateGame < dateToday) {
      style = "schedule-offboard";
    }
    return style;
  };

  const [datesRow,setDatesRow] = useState([])
  const handleClickCheckEvent = (
    event,
    name,
    idLeagueSelected,
    parentGame,
    homeNumber,
    visitorNumber,
    visitorOdds,
    row
  ) => {
    props.handleClickCheck(name, visitorOdds);

    setselectedIdLeague(idLeagueSelected);
    setSelectedLeagueName(row?.LeagueDescription || "");
    setParentGame(parentGame);
    setHomeNumber(homeNumber);
    setVisitorNumber(visitorNumber);
    setRotation(visitorOdds);

    console.log(row)
    // if (event.target.checked) {
    //   console.log(event.target.checked)
    //   setDatesRow((prev) => [...prev, row]);
    // } else {
    //   setDatesRow((prev) => prev.filter((item) => item.idGame !== name));
    // }
    setDatesRow((prevDatesRow) => {
      const isSelected = prevDatesRow.some((item) => item.idGame === row.idGame);
      if (isSelected) {
        return prevDatesRow.filter((item) => item.idGame !== row.idGame);
      } else {
        return [...prevDatesRow, row];
      }
    });
  };

  useEffect(()=>{
    if (datesRow.length > 0) {
      const lastRow = datesRow[datesRow.length - 1];
      setselectedIdLeague(lastRow.idLeague);
      setParentGame(lastRow.parentGame);
      setHomeNumber(lastRow.homeNumber);
      setVisitorNumber(lastRow.visitorNumber);
      setRotation(lastRow.visitorOdds);
    }
  },[datesRow])

  const isSelected = (name, name2) =>
    props.IdSport.trim() != "TNT"
      ? props.selectedGame.indexOf(name) !== -1
      : props.selectedGame.indexOf(name2) !== -1;

  const handleContextMenu = useCallback((e) => {
    // e.preventDefault();
  });
  
  const resetDatesRow=()=>{
    setDatesRow([])
  }

  document.addEventListener("contextmenu", handleContextMenu);
  //document.addEventListener('contextmenu', useEventListener);
  const useEventListener1 = (eventName, handler, element = window) => {
    // Create a ref that stores handler
    const savedHandler = useRef();

    useEffect(() => {
      savedHandler.current = handler;
    }, [handler]);

    useEffect(
      () => {
        // Make sure element supports addEventListener
        // On
        const isSupported = element && element.addEventListener;
        if (!isSupported) return;

        // Create event listener that calls handler function stored in ref
        const eventListener = (event) => savedHandler.current(event);

        // Add event listener
        element.addEventListener(eventName, eventListener);

        // Remove event listener on cleanup
        return () => {
          element.removeEventListener(eventName, eventListener);
        };
      },
      [eventName, element] // Re-run if eventName or element changes
    );
  };
  function StyledCheckbox(props) {
    const classesCk = useStylesCheck();

    return (
      <Checkbox
        className={classesCk.root}
        disableRipple
        color="default"
        checkedIcon={
          <span className={clsx(classesCk.icon, classesCk.checkedIcon)} />
        }
        icon={<span className={classesCk.icon} />}
        inputProps={{ "aria-label": "decorative checkbox" }}
        {...props}
      />
    );
  }

  const [hiddenGames, setHiddenGames] = useState({});

  const toggleVisibility = (gameDateTime, leagueDescription) => {
    const key = `${gameDateTime}-${leagueDescription}`;
    setHiddenGames((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };


  const toggleSelection = (rows) => {
    
    const allSelected = rows.every((row) =>
      props.IdSport.trim() !== "TNT"
        ? props.selectedGame.includes(row.idGame)
        : props.selectedGame.includes(row.visitorOdds)
    );
  
    let newSelected = [...props.selectedGame];
    let newDatesRow = [...datesRow];
  
    if (allSelected) {
      newSelected = newSelected.filter((game) =>
        props.IdSport.trim() !== "TNT"
          ? !rows.some((row) => row.idGame === game)
          : !rows.some((row) => row.visitorOdds === game)
      );
  
      newDatesRow = newDatesRow.filter(
        (item) => !rows.some((row) => row.idGame === item.idGame)
      );
      if (newDatesRow.length > 0) {
        const lastRow = newDatesRow[newDatesRow.length - 1];
        setselectedIdLeague(lastRow.idLeague);
        setParentGame(lastRow.parentGame);
        setHomeNumber(lastRow.homeNumber);
        setVisitorNumber(lastRow.visitorNumber);
        setRotation(lastRow.visitorOdds);
      }
    } else {
      rows.forEach((row) => {
        const key = props.IdSport.trim() !== "TNT" ? row.idGame : row.visitorOdds;
        if (!newSelected.includes(key)) {
          newSelected.push(key);
        }
  
        const isRowSelected = newDatesRow.some((item) => item.idGame === row.idGame);
        if (!isRowSelected) {
          newDatesRow.push(row);
        }

        setselectedIdLeague(row.idLeague);
        setParentGame(row.parentGame);
        setHomeNumber(row.homeNumber);
        setVisitorNumber(row.visitorNumber);
        setRotation(row.visitorOdds);
      });
    }
  
    props.setSelectedGame(newSelected);
    setDatesRow(newDatesRow);
  };
  
  const SettingEvent = () =>{
    // console.log(datesRow)
    if (datesRow.length === 0) return; // Si el array está vacío, no hacer nada

    const firstIdLeague = datesRow[0].idLeague;
    const allSameLeague = datesRow.every(row => row.idLeague === firstIdLeague);

    if (allSameLeague) {
      setIsEvent(true);
    } else {
      toast.error("The selected games should be from the same league.");
    }
  }

  const renderColumns = (row, sportId) => {
    const columnOrder = getOrderForSport(sportId);
  
    return columnOrder.map((column) => {
      switch (column) {
        case "Spread":
          return (
            <>
              {row.gameStat !== "B" ? (
                          <TableCell className={classes.headerCell}>
                            <DelayInput
                              minLength={1}
                              type="text"
                              delayTimeout={2000}
                              className="schedule-text-box-input !text-black !w-[55px]"
                              // value={
                              //   localValues[row.idGame]?.VisitorSpread ?? 
                              //   (row.visitorSpread == null 
                              //     ? "" 
                              //     : row.visitorSpread === 0 
                              //     ? "PK" 
                              //     : row.visitorSpread)
                              // }
                              value={
                                localValues[row.idGame]?.VisitorSpread ??
                                (props.IdSport.trim() === "NHL"
                                  ? row.visitorSpecial == null
                                    ? ""
                                    : row.visitorSpecial === 0
                                    ? "PK"
                                    : row.visitorSpecial
                                  : row.visitorSpread == null
                                  ? ""
                                  : row.visitorSpread === 0
                                  ? "PK"
                                  : row.visitorSpread)
                              }
                              onKeyDown={(event) => {
                                if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                  event.preventDefault();
                                  GetLinesHistoryVisitor(row, 0, row.visitorNumber);  
                                  GetLinesHistoryHome(row, 0, row.homeNumber);
                                  return;
                                }
                                if (event.key == "Enter") {
                                  const rowChanged = spreadsChanged[row.idGame] || { firstChanged: false, secondChanged: false };
                                  const updatedRow = localValues[row.idGame];
                                  
                                  if (rowChanged.secondChanged) {
                                    console.log("si cambio el second, se haran las 2.")

                                    updateSP(
                                      row.idGame,
                                      row.overOdds,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.visitorNumber,
                                      props.IdSport.trim() != "NHL" ? 0 : 7,
                                      8,
                                      1,
                                      0,
                                      row.homeNumber,
                                      row.idGameType,
                                      9,
                                      1,
                                      false
                                    );
                                    updateSP(
                                      row.idGame,
                                      updatedRow.VisitorSpreadOdds,
                                      props.IdLinetype,
                                      row.overOdds,
                                      props.IdSport.trim(),
                                      row.visitorNumber,
                                      props.IdSport.trim() != "NHL" ? 0 : 7,
                                      8,
                                      0,
                                      1,
                                      row.homeNumber,
                                      row.idGameType,
                                      9,
                                      1,
                                      true
                                    );
                                    setSpreadsChanged((prev) => ({
                                      ...prev,
                                      [row.idGame]: { firstChanged: false, secondChanged: false }
                                    }));
                                    // setLocalValues({})

                                  }else{
                                    updateSP(
                                      row.idGame,
                                      row.overOdds,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.visitorNumber,
                                      props.IdSport.trim() != "NHL" ? 0 : 7,
                                      8,
                                      1,
                                      0,
                                      row.homeNumber,
                                      row.idGameType,
                                      9,
                                      1,
                                      false
                                    );
                                    setSpreadsChanged((prev) => ({
                                      ...prev,
                                      [row.idGame]: { firstChanged: false, secondChanged: false }
                                    }));
                                    // setLocalValues({})
                                  }

                                  /*props.announce(row.idGame, props.IdLinetype);*/
                                }
                              }}
                              onChange={(event) => {
                                setValueHasChanged(true);
                                setSpreadsChanged((prev) => ({
                                  ...prev,
                                  [row.idGame]: { ...prev[row.idGame], firstChanged: true}
                                }));
                                handleInputChange(row.idGame, "VisitorSpread", event.target.value);
                              }}
                            />
                            <DelayInput
                              minLength={1}
                              delayTimeout={2000}
                              type="number"
                              className="schedule-text-box-input !text-black !w-[55px]"
                              // value={
                              //   localValues[row.idGame]?.VisitorSpreadOdds ?? (row.visitorSpreadOdds == 0 || row.visitorSpreadOdds == null ? "" : row.visitorSpreadOdds)
                              // }
                              value={
                                localValues[row.idGame]?.VisitorSpreadOdds ??
                                (props.IdSport.trim() === "NHL"
                                  ? row.visitorSpecialOdds === 0 || row.visitorSpecialOdds == null
                                    ? ""
                                    : row.visitorSpecialOdds
                                  : row.visitorSpreadOdds === 0 || row.visitorSpreadOdds == null
                                  ? ""
                                  : row.visitorSpreadOdds)
                              }
                              onKeyDown={(event) => {
                                if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                  event.preventDefault(); 
                                  GetLinesHistoryVisitor(row, 0, row.visitorNumber);  
                                  GetLinesHistoryHome(row, 0, row.homeNumber);
                                  return;
                                }
                                if (event.key == "Enter") {

                                  const rowChanged = spreadsChanged[row.idGame] || { firstChanged: false, secondChanged: false };
                                  const updatedRow = localValues[row.idGame];

                                  if (rowChanged.firstChanged) {
                                    console.log("Si cambio el first, se haran los 2.")
                                    updateSP(
                                      row.idGame,
                                      event.target.value,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.visitorNumber,
                                      props.IdSport.trim() != "NHL" ? 0 : 7,
                                      8,
                                      0,
                                      1,
                                      row.homeNumber,
                                      row.idGameType,
                                      9,
                                      1,
                                      true
                                    );

                                    updateSP(
                                      row.idGame,
                                      row.overOdds,
                                      props.IdLinetype,
                                      updatedRow.VisitorSpread,
                                      props.IdSport.trim(),
                                      row.visitorNumber,
                                      props.IdSport.trim() != "NHL" ? 0 : 7,
                                      8,
                                      1,
                                      0,
                                      row.homeNumber,
                                      row.idGameType,
                                      9,
                                      1,
                                      false
                                    );
                                    setSpreadsChanged((prev) => ({
                                      ...prev,
                                      [row.idGame]: { firstChanged: false, secondChanged: false }
                                    }));
                                    // setLocalValues({})
                                  }else{
                                    updateSP(
                                      row.idGame,
                                      event.target.value,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.visitorNumber,
                                      props.IdSport.trim() != "NHL" ? 0 : 7,
                                      8,
                                      0,
                                      1,
                                      row.homeNumber,
                                      row.idGameType,
                                      9,
                                      1,
                                      true
                                    );
                                    setSpreadsChanged((prev) => ({
                                      ...prev,
                                      [row.idGame]: { firstChanged: false, secondChanged: false }
                                    }));
                                    // setLocalValues({})
                                  }
                                  
                                  /*props.announce(row.idGame, props.IdLinetype);*/
                                }
                              }}
                              onChange={(event) => {
                                setValueHasChanged(true);
                                setSpreadsChanged((prev) => ({
                                  ...prev,
                                  [row.idGame]: { ...prev[row.idGame], secondChanged: true }
                                }));
                                handleInputChange(row.idGame, "VisitorSpreadOdds", event.target.value);
                              }}
                            />
                            <br />
                            <DelayInput
                              minLength={1}
                              delayTimeout={2000}
                              type="text"
                              className="schedule-text-box-input !text-black !w-[55px]"
                              value={
                                localValues[row.idGame]?.HomeSpread ??
                                (props.IdSport.trim() === "NHL"
                                  ? row.homeSpecial == null
                                    ? ""
                                    : row.homeSpecial === 0
                                    ? "PK"
                                    : row.homeSpecial
                                  : row.homeSpread == null
                                  ? ""
                                  : row.homeSpread === 0
                                  ? "PK"
                                  : row.homeSpread)
                              }
                              onKeyDown={(event) => {
                                 if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                    event.preventDefault(); 
                                    GetLinesHistoryVisitor(row, 1, row.visitorNumber);  
                                    GetLinesHistoryHome(row, 1, row.homeNumber);
                                    return;
                                  }
                                if (event.key == "Enter") {
                                  const rowChanged = spreadsChanged[row.idGame] || { thirdChanged: false, fourthChanged: false };
                                  const updatedRow = localValues[row.idGame];

                                  if (rowChanged.fourthChanged) {
                                    console.log("El cuarto cambió, se harán ambas operaciones");
                                    updateSP(
                                      row.idGame,
                                      row.underOdds,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.homeNumber,
                                      props.IdSport.trim() != "NHL" ? 1 : 8,
                                      9,
                                      1,
                                      0,
                                      row.visitorNumber,
                                      row.idGameType,
                                      8,
                                      0,
                                      false
                                    );
                                    updateSP(
                                      row.idGame,
                                      updatedRow.HomeSpreadOdds,
                                      props.IdLinetype,
                                      updatedRow.HomeSpreadOdds,
                                      props.IdSport.trim(),
                                      row.homeNumber,
                                      props.IdSport.trim() != "NHL" ? 1 : 8,
                                      9,
                                      0,
                                      1,
                                      row.visitorNumber,
                                      row.idGameType,
                                      8,
                                      0,
                                      true
                                    );

                                    setSpreadsChanged((prev) => ({
                                      ...prev,
                                      [row.idGame]: { thirdChanged: false, fourthChanged: false }
                                    }));
                                    // setLocalValues({})
                                  }else{
                                    updateSP(
                                      row.idGame,
                                      row.underOdds,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.homeNumber,
                                      props.IdSport.trim() != "NHL" ? 1 : 8,
                                      9,
                                      1,
                                      0,
                                      row.visitorNumber,
                                      row.idGameType,
                                      8,
                                      0,
                                      false
                                    );
                                    setSpreadsChanged((prev) => ({
                                      ...prev,
                                      [row.idGame]: { thirdChanged: false, fourthChanged: false }
                                    }));
                                    // setLocalValues({})
                                  }
                          
                                  /*props.announce(row.idGame, props.IdLinetype);*/
                                  //props.searchGameValues();
                                }
                              }}
                              onChange={(event) => {
                                setValueHasChanged(true);
                                setSpreadsChanged((prev) => ({
                                  ...prev,
                                  [row.idGame]: { ...prev[row.idGame], thirdChanged: true }
                                }));
                                handleInputChange(row.idGame, "HomeSpread", event.target.value);
                              }}
                            />
                            <DelayInput
                              minLength={1}
                              delayTimeout={2000}
                              type="number"
                              className="schedule-text-box-input !text-black !w-[55px]"
                              // value={
                              //   localValues[row.idGame]?.HomeSpreadOdds ?? 
                              //   (row.homeSpreadOdds == 0 || row.homeSpreadOdds == null ? "" : row.homeSpreadOdds)
                              // }
                              value={
                                localValues[row.idGame]?.HomeSpreadOdds ??
                                (props.IdSport.trim() === "NHL"
                                  ? row.homeSpecialOdds === 0 || row.homeSpecialOdds == null
                                    ? ""
                                    : row.homeSpecialOdds
                                  : row.homeSpreadOdds === 0 || row.homeSpreadOdds == null
                                  ? ""
                                  : row.homeSpreadOdds)
                              }
                              onKeyDown={(event) => {
                                 if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                    event.preventDefault(); 
                                    GetLinesHistoryVisitor(row, 1, row.visitorNumber);  
                                    GetLinesHistoryHome(row, 1, row.homeNumber);
                                    return;
                                  }
                                if (event.key == "Enter") {
                                  const rowChanged = spreadsChanged[row.idGame] || { thirdChanged: false, fourthChanged: false };
                                  const updatedRow = localValues[row.idGame];
                                  if (rowChanged.thirdChanged) {
                                    console.log("El tercero cambió, se harán ambas operaciones");
                                    updateSP(
                                      row.idGame,
                                      event.target.value,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.homeNumber,
                                      props.IdSport.trim() != "NHL" ? 1 : 8,
                                      9,
                                      0,
                                      1,
                                      row.visitorNumber,
                                      row.idGameType,
                                      8,
                                      0,
                                      true
                                    );

                                    updateSP(
                                      row.idGame,
                                      row.underOdds,
                                      props.IdLinetype,
                                      updatedRow.HomeSpread,
                                      props.IdSport.trim(),
                                      row.homeNumber,
                                      props.IdSport.trim() != "NHL" ? 1 : 8,
                                      9,
                                      1,
                                      0,
                                      row.visitorNumber,
                                      row.idGameType,
                                      8,
                                      0,
                                      false
                                    );
                                    setSpreadsChanged((prev) => ({
                                      ...prev,
                                      [row.idGame]: { thirdChanged: false, fourthChanged: false }
                                    }));
                                    // setLocalValues({})

                                  }else{
                                    updateSP(
                                      row.idGame,
                                      event.target.value,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.homeNumber,
                                      props.IdSport.trim() != "NHL" ? 1 : 8,
                                      9,
                                      0,
                                      1,
                                      row.visitorNumber,
                                      row.idGameType,
                                      8,
                                      0,
                                      true
                                    );
                                    setSpreadsChanged((prev) => ({
                                      ...prev,
                                      [row.idGame]: { thirdChanged: false, fourthChanged: false }
                                    }));
                                    // setLocalValues({})
                                  }
                                  /*props.announce(row.idGame, props.IdLinetype);*/
                                }
                              }}
                              onChange={(event) => {
                                setValueHasChanged(true);
                                setSpreadsChanged((prev) => ({
                                  ...prev,
                                  [row.idGame]: { ...prev[row.idGame], fourthChanged: true }
                                }));
                                handleInputChange(row.idGame, "HomeSpreadOdds", event.target.value);
                              }}
                            />
                          </TableCell>
              ) : (
                ""
              )}

              {row.gameStat !== "B" ? (
                          <TableCell className={classes.headerCell}>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setselectedPlay(0);
                                setPoints(row.visitorSpread);
                                setIsCharting(true);
                              }}
                              
                            >
                              {row.spreadVisitorAction}
                            </Link>
                            <br></br>
                            <br></br>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setselectedPlay(1);
                                setPoints(row.homeSpread);
                                setIsCharting(true);
                              }}
                            >
                              {row.spreadHomeAction}
                            </Link>
                          </TableCell>
              ) : (
                ""
              )}
              {row.gameStat !== "B" ? (
                          <TableCell>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setIsCharting(true);
                              }}
                            >
                              {row.spreadVisitorCount}
                            </Link>
                            <br></br>
                            <br></br>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setIsCharting(true);
                              }}
                            >
                              {row.spreadHomeCount}
                            </Link>
                          </TableCell>
              ) : (
                ""
              )}
            </>
          );
        case "Totals":
          return (
            <>
                  {row.gameStat !== "B" ? (
                          <TableCell className={classes.headerCell}>
                            {"O "}
                            {
                              <DelayInput
                                minLength={1}
                                type="number"
                                delayTimeout={2000}
                                className="schedule-text-box-input !text-black !w-[55px]"
                                value={
                                  localValues[row.idGame]?.TotalOver ?? (row.totalOver == 0 || row.totalOver == null ? "" : row.totalOver)
                                }
                                onKeyDown={(event) => {
                                   if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                      event.preventDefault(); 
                                      GetLinesHistoryVisitor(row, 2, row.visitorNumber);  
                                      GetLinesHistoryHome(row, 2, row.homeNumber);
                                      return;
                                    }
                                  if (event.key == "Enter") {
                                    const rowChanged = inputsChanged[row.idGame] || { firstChanged: false, secondChanged: false };
                                    const updatedRow = localValues[row.idGame]
                                    if (rowChanged.secondChanged) {

                                      console.log("si cambio el second, se haran las 2")

                                      updateTO(
                                        row.idGame,
                                        updatedRow.OverOdds,  
                                        props.IdLinetype,
                                        event.target.value,  
                                        props.IdSport.trim(),
                                        row.visitorNumber,
                                        2,
                                        8,
                                        1,
                                        0,
                                        row.homeNumber,
                                        row.idGameType,
                                        9,
                                        3,
                                        true
                                      );
                                      updateTO(
                                        row.idGame,
                                        updatedRow.OverOdds,  
                                        props.IdLinetype,
                                        updatedRow.OverOdds, 
                                        props.IdSport.trim(),
                                        row.visitorNumber,
                                        2,
                                        9,
                                        0,
                                        1,
                                        row.homeNumber,
                                        row.idGameType,
                                        9,
                                        3,
                                        false
                                      );

                                      setInputsChanged((prev) => ({
                                        ...prev,
                                        [row.idGame]: { firstChanged: false, secondChanged: false }
                                      }));
                                      // setLocalValues({})
                                    }else{
                                      console.log("no cambio el second, solo se hara este")

                                      updateTO(
                                        row.idGame,
                                        row.overOdds,  // Valor de OverOdds
                                        props.IdLinetype,
                                        event.target.value,  // Valor del primer input (TotalOver)
                                        props.IdSport.trim(),
                                        row.visitorNumber,
                                        2,
                                        8,
                                        1,
                                        0,
                                        row.homeNumber,
                                        row.idGameType,
                                        9,
                                        3,
                                        true
                                      );

                                      setInputsChanged((prev) => ({
                                        ...prev,
                                        [row.idGame]: { firstChanged: false, secondChanged: false }
                                      }));
                                      // setLocalValues({})
                                    }
                                    /*props.announce(row.idGame, props.IdLinetype);*/
                                  }
                                }}
                                onChange={(event) => {
                                  setValueHasChanged(true);
                                  setInputsChanged((prev) => ({
                                    ...prev,
                                    [row.idGame]: { ...prev[row.idGame], firstChanged: true}
                                  }));
                                  handleInputChange(row.idGame, "TotalOver", event.target.value);
                                }}
                              />
                            }
                            {
                              <DelayInput
                                minLength={1}
                                type="number"
                                delayTimeout={2000}
                                className="schedule-text-box-input !text-black !w-[55px]"
                                value={
                                  localValues[row.idGame]?.OverOdds ?? (row.overOdds == 0 || row.overOdds == null ? "" : row.overOdds)
                                }
                                onKeyDown={(event) => {
                                  if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                      event.preventDefault(); 
                                      GetLinesHistoryVisitor(row, 2, row.visitorNumber);  
                                      GetLinesHistoryHome(row, 2, row.homeNumber);
                                      return;
                                    }
                                  if (event.key == "Enter") {
                                    const rowChanged = inputsChanged[row.idGame] || { firstChanged: false, secondChanged: false };
                                    const updatedRow = localValues[row.idGame]
                                    if (rowChanged.firstChanged) {
                                      console.log("Si cambio el first, se haran los 2.")
                                      updateTO(
                                        row.idGame,
                                        row.overOdds,
                                        props.IdLinetype,
                                        updatedRow.TotalOver,  // Valor del primer input (TotalOver)
                                        props.IdSport.trim(),
                                        row.visitorNumber,
                                        2,
                                        8,
                                        1,
                                        0,
                                        row.homeNumber,
                                        row.idGameType,
                                        9,
                                        3,
                                        true
                                      );
                                      updateTO(
                                        row.idGame,
                                        event.target.value,
                                        props.IdLinetype,
                                        row.overOdds, 
                                        props.IdSport.trim(),
                                        row.visitorNumber,
                                        2,
                                        9,
                                        0,
                                        1,
                                        row.homeNumber,
                                        row.idGameType,
                                        9,
                                        3,
                                        false
                                      );

                                      setInputsChanged((prev) => ({
                                        ...prev,
                                        [row.idGame]: { firstChanged: false, secondChanged: false }
                                      }));
                                      // setLocalValues({})
                                    }else{
                                      console.log("NO cambio el first, se hara solo este.")

                                      updateTO(
                                        row.idGame,
                                        event.target.value, 
                                        props.IdLinetype,
                                        row.overOdds,
                                        props.IdSport.trim(),
                                        row.visitorNumber,
                                        2,
                                        9,
                                        0,
                                        1,
                                        row.homeNumber,
                                        row.idGameType,
                                        9,
                                        3,
                                        false
                                      );

                                      setInputsChanged((prev) => ({
                                          ...prev,
                                          [row.idGame]: { firstChanged: false, secondChanged: false }
                                        }));
                                      // setLocalValues({})
                                    }
                                    /*props.announce(row.idGame, props.IdLinetype);*/
                                  }
                                }}
                                onChange={(event) => {
                                  setValueHasChanged(true);
                                  setInputsChanged((prev) => ({
                                    ...prev,
                                    [row.idGame]: { ...prev[row.idGame], secondChanged: true }
                                  }));
                                  handleInputChange(row.idGame, "OverOdds", event.target.value);
                                }}
                              />
                            }
                            <br></br>
                            {"U "}

                            {
                              <DelayInput
                                minLength={1}
                                type="number"
                                delayTimeout={2000}
                                className={`${" schedule-text-box-input !text-black !w-[55px]"}`}
                                value={
                                  localValues[row.idGame]?.TotalUnder ??
                                  (row.totalUnder == 0 || row.totalUnder == null ? "" : row.totalUnder)
                                }
                                onKeyDown={(event) => {
                                  if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                      event.preventDefault(); 
                                      GetLinesHistoryVisitor(row, 3, row.visitorNumber);  
                                      GetLinesHistoryHome(row, 3, row.homeNumber);
                                      return;
                                    }
                                  if (event.key == "Enter") {

                                    const rowChanged = inputsChanged[row.idGame] || { thirdChanged: false, fourthChanged: false };
                                    const updatedRow = localValues[row.idGame];

                                    if (rowChanged.fourthChanged) {
                                      console.log("El cuarto cambió, se harán ambas operaciones");
                            
                                      updateTO(
                                        row.idGame,
                                        updatedRow.UnderOdds,
                                        props.IdLinetype,
                                        event.target.value, // Valor de TotalUnder
                                        props.IdSport.trim(),
                                        row.homeNumber,
                                        3,
                                        8,
                                        1,
                                        0,
                                        row.visitorNumber,
                                        row.idGameType,
                                        9,
                                        2,
                                        true
                                      );
                            
                                      updateTO(
                                        row.idGame,
                                        updatedRow.UnderOdds, // Valor de TotalUnder
                                        props.IdLinetype,
                                        updatedRow.UnderOdds, // Valor de UnderOdds
                                        props.IdSport.trim(),
                                        row.homeNumber,
                                        3,
                                        9,
                                        0,
                                        1,
                                        row.visitorNumber,
                                        row.idGameType,
                                        9,
                                        2,
                                        false
                                      );
                            
                                      setInputsChanged((prev) => ({
                                        ...prev,
                                        [row.idGame]: { thirdChanged: false, fourthChanged: false }
                                      }));
                                      // setLocalValues({})
                                    } else {
                                      console.log("El cuarto no cambió, solo se hará este");
                            
                                      updateTO(
                                        row.idGame,
                                        row.underOdds,
                                        props.IdLinetype,
                                        event.target.value, // Valor de TotalUnder
                                        props.IdSport.trim(),
                                        row.homeNumber,
                                        3,
                                        8,
                                        1,
                                        0,
                                        row.visitorNumber,
                                        row.idGameType,
                                        9,
                                        2,
                                        true
                                      );
                            
                                      setInputsChanged((prev) => ({
                                        ...prev,
                                        [row.idGame]: { thirdChanged: false, fourthChanged: false }
                                      }));
                                      // setLocalValues({})

                                    /*props.announce(row.idGame, props.IdLinetype);*/
                                  }
                                }}
                                }
                                onChange={(event) => {
                                  setValueHasChanged(true);
                                  setInputsChanged((prev) => ({
                                    ...prev,
                                    [row.idGame]: { ...prev[row.idGame], thirdChanged: true }
                                  }));
                                  handleInputChange(row.idGame, "TotalUnder", event.target.value);
                                }}
                              />
                            }
                            {
                              <DelayInput
                                minLength={1}
                                type="number"
                                delayTimeout={2000}
                                className="schedule-text-box-input !text-black !w-[55px]"
                                value={
                                  localValues[row.idGame]?.UnderOdds ?? 
                                  (row.underOdds == 0 || row.underOdds == null ? "" : row.underOdds)
                                }
                                onKeyDown={(event) => {
                                  if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                      event.preventDefault(); 
                                      GetLinesHistoryVisitor(row, 3, row.visitorNumber);  
                                      GetLinesHistoryHome(row, 3, row.homeNumber);
                                      return;
                                    }
                                  if (event.key == "Enter") {

                                    const rowChanged = inputsChanged[row.idGame] || { thirdChanged: false, fourthChanged: false };
                                    const updatedRow = localValues[row.idGame];

                                    if (rowChanged.thirdChanged) {
                                      console.log("El tercero cambió, se harán ambas operaciones");

                                      updateTO(
                                        row.idGame,
                                        event.target.value, // Valor de UnderOdds
                                        props.IdLinetype,
                                        updatedRow.TotalUnder, // Valor de TotalUnder
                                        props.IdSport.trim(),
                                        row.homeNumber,
                                        3,
                                        8,
                                        1,
                                        0,
                                        row.visitorNumber,
                                        row.idGameType,
                                        9,
                                        2,
                                        true
                                      );

                                      updateTO(
                                        row.idGame,
                                        event.target.value, // Valor de UnderOdds
                                        props.IdLinetype,
                                        event.target.value, // Valor de TotalUnder
                                        props.IdSport.trim(),
                                        row.homeNumber,
                                        3,
                                        9,
                                        0,
                                        1,
                                        row.visitorNumber,
                                        row.idGameType,
                                        9,
                                        2,
                                        false
                                      );

                                      setInputsChanged((prev) => ({
                                        ...prev,
                                        [row.idGame]: { thirdChanged: false, fourthChanged: false }
                                      }));
                                      // setLocalValues({})
                                    } else {
                                      console.log("El tercero no cambió, solo se hará este");

                                      updateTO(
                                        row.idGame,
                                        event.target.value, 
                                        props.IdLinetype,
                                        event.target.value, 
                                        props.IdSport.trim(),
                                        row.homeNumber,
                                        3,
                                        9,
                                        0,
                                        1,
                                        row.visitorNumber,
                                        row.idGameType,
                                        9,
                                        2,
                                        false
                                      );

                                      setInputsChanged((prev) => ({
                                        ...prev,
                                        [row.idGame]: { thirdChanged: false, fourthChanged: false }
                                      }));
                                      // setLocalValues({})
                                    }
          
                                    /*props.announce(row.idGame, props.IdLinetype);*/
                                  }
                                }}
                                onChange={(event) => {
                                  setValueHasChanged(true);
                                  setInputsChanged((prev) => ({
                                    ...prev,
                                    [row.idGame]: { ...prev[row.idGame], fourthChanged: true }
                                  }));
                                  handleInputChange(row.idGame, "UnderOdds", event.target.value);
                                }}
                              />
                            }
                          </TableCell>
                  ) : (
                    ""
                  )}

                  {row.gameStat !== "B" ? (
                          <TableCell className={`${classes.headerCell} !text-[#eb0a0a]`}>
                            {row.totalVisitorAction}
                            <br></br>
                            <br></br>
                            {row.totalHomeAction}
                          </TableCell>
                  ) : (
                    ""
                  )}
                  {row.gameStat !== "B" ? (
                          <TableCell className={classes.headerCell}>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setselectedPlay(2);
                                setPoints(row.totalOver);
                                setIsCharting(true);
                              }}
                            >
                              {row.totalVisitorCount}
                            </Link>

                            <br></br>

                            <br></br>

                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setselectedPlay(3);
                                setPoints(row.totalUnder);
                                setIsCharting(true);
                              }}
                            >
                              {row.totalHomeCount}
                            </Link>
                          </TableCell>
                  ) : (
                    ""
                  )}
            </>
          );
        case "ML":
          return (
            <>
                {row.gameStat !== "B" ? (
                          <TableCell className={classes.headerCell}>
                            {
                              <DelayInput
                                minLength={1}
                                type="number"
                                delayTimeout={2000}
                                className={`${" schedule-text-box-input !text-black !w-[70px]"}`}
                                value={
                                  row.visitorOdds == 0 ||
                                  row.visitorOdds == null
                                    ? ""
                                    : row.visitorOdds
                                }
                                onKeyDown={(event) => {
                                  if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                      event.preventDefault(); 
                                      GetLinesHistoryVisitor(row, 4, row.visitorNumber);  
                                      GetLinesHistoryHome(row, 5, row.homeNumber);
                                      return;
                                    }
                                  if (event.key == "Enter") {
                                    updateML(
                                      row.idGame,
                                      row.visitorOdds,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.visitorNumber,
                                      4,
                                      8,
                                      1,
                                      0,
                                      row.homeNumber,
                                      row.idGameType,
                                      8,
                                      5,
                                      row.idLeague
                                    );
                                    /*props.announce(
                                      row.idGame,
                                      props.IdLinetype
                                    );*/
                                  }
                                }}
                                onChange={() => {
                                  setValueHasChanged(true);
                                }}
                              />
                            }
                            <br></br>
                            <DelayInput
                              minLength={1}
                              type="number"
                              delayTimeout={2000}
                              className={`${" schedule-text-box-input !text-black !w-[70px]"}`}
                              value={
                                row.homeOdds == 0 || row.homeOdds == null
                                  ? ""
                                  : row.homeOdds
                              }
                              onKeyDown={(event) => {
                                if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                      event.preventDefault(); 
                                      GetLinesHistoryVisitor(row, 4, row.visitorNumber);  
                                      GetLinesHistoryHome(row, 5, row.homeNumber);
                                      return;
                                    }
                                if (event.key == "Enter") {
                                  updateML(
                                    row.idGame,
                                    row.homeOdds,
                                    props.IdLinetype,
                                    event.target.value,
                                    props.IdSport.trim(),
                                    row.visitorNumber,
                                    5,
                                    8,
                                    1,
                                    0,
                                    row.homeNumber,
                                    row.idGameType,
                                    8,
                                    4
                                  );
                                }
                              }}
                              onChange={() => {
                                setValueHasChanged(true);
                              }}
                            />
                            <br></br>
                            {props.IdSport.trim() == "SOC" ? (
                              <DelayInput
                                minLength={1}
                                type="number"
                                delayTimeout={2000}
                                className="schedule-text-box-input !text-black !w-[70px]"
                                value={
                                  row.visitorSpecialOdds == 0 ||
                                  row.visitorSpecialOdds == null
                                    ? ""
                                    : row.visitorSpecialOdds
                                }
                                onKeyDown={(event) => {
                                  if (event.ctrlKey && event.key.toLowerCase() === "l") {
                                      event.preventDefault(); 
                                      GetLinesHistoryVisitor(row, 6, row.visitorNumber); 
                                      setLineHistoryModal(true); 
                                      setIsDraw(true);
                                      setLinesHistoryHome([]);
                                      // GetLinesHistoryHome(row, 6, row.homeNumber);
                                      return;
                                    }
                                  if (event.key == "Enter") {
                                    updateDraw(
                                      row.idGame,
                                      row.visitorSpecialOdds,
                                      props.IdLinetype,
                                      event.target.value,
                                      props.IdSport.trim(),
                                      row.visitorNumber,
                                      6,
                                      8,
                                      1,
                                      0,
                                      row.homeNumber,
                                      row.idGameType,
                                      8,
                                      4
                                    );
                                  }
                                }}
                                onChange={() => {
                                  setValueHasChanged(true);
                                }}
                              />
                            ) : (
                              ""
                            )}
                          </TableCell>
                ) : (
                  ""
                )}

                {row.gameStat !== "B" ? (
                          <TableCell className={classes.headerCell}>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setselectedPlay(4);
                                setPoints(row.visitorOdds);
                                setIsCharting(true);
                              }}
                            >
                              {row.mlVisitorAction}
                            </Link>

                            <br></br>
                            <br></br>

                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setselectedPlay(5);
                                setPoints(row.homeOdds);
                                setIsCharting(true);
                              }}
                            >
                              {row.mlHomeAction}
                            </Link>
                          </TableCell>
                ) : (
                  ""
                )}
                {row.gameStat !== "B" ? (
                          <TableCell className={classes.headerCell}>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setIsCharting(true);
                              }}
                            >
                              {row.mlVisitorCount}
                            </Link>
                            <br></br>
                            <br></br>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                setHomeTeam(row.homeTeam);
                                setVisitorTeam(row.visitorTeam);
                                setselectedIdGame(row.idGame);
                                setIsCharting(true);
                              }}
                            >
                              {row.mlHomeCount}
                            </Link>
                          </TableCell>
                ) : (
                  ""
                )}
            </>
          );
        default:
          return null;
      }
    });
  };
  

  const SendToGrade = (event) => {
    // event.preventDefault();
    // console.log("CTRL+G")
    // axios({
    //   method: "post",
    //   url: process.env.REACT_APP_APICORE_URL + "/Wager/GradeGamesFromDB",
    // }).then((response) => {
    // if(response.data){
    //   toast.success("Grading done.");
    // }else{
    //   toast.error("An error has occurred.");
    // }
    //   console.log("response", response);
    //   handleClose();
    // });
  };

  // useEventListener1('mousemove', handler);
  let previousRow = null;

  return (
    <React.Fragment>
      <KeyboardEventHandler
        handleKeys={[
          "alt+d",
          "alt+i",
          "alt+m",
          "alt+b",
          "alt+t",
          "alt+s",
          "alt+n",
        ]}
        onKeyEvent={(key, e) => setEventKey(key, e)}
      />
      {isNew ? (
        <CreateGame
          IdLinetype={props.IdLinetype}
          IdSport={props.IdSport.trim()}
          onClose={handleCloseCreate}
          searchGameValues={props.searchGameValues}
        />
      ) : (
        ""
      )}

      <div className="table-toolbar">
        <div
          className="toolbar-item toolbar-item-primary"
          onClick={() => {
            setIsNew(true);
          }}
        >
          <span>Add New Game</span>
        </div>
        {isChecked ? (
          <>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsDelete(true);
              }}
            >
              <span>Delete Game</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsPeriod(true);
              }}
            >
              <span>Game Periods</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                SettingEvent();
              }}
            >
              <span>Add Event</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setNewBanner(true);
              }}
            >
              <span>Add Banner</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsStatus(true);
              }}
            >
              <span>Game Status</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsModify(true);
              }}
            >
              <span>Modify Game</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsSettings(true);
              }}
            >
              <span>Settings</span>
            </div>
            {props.selectedGame.length === 1 ? (
              <div
                className="toolbar-item"
                onClick={() => {
                  setIsHidden(true);
                }}
              >
                <span>Hide Values</span>
              </div>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}
      </div>
      <div className="schedule" style={{ width: "100%", marginTop: "16px", maxHeight: "75vh" }}>
        <Table
          className={classes.table}
          component={Paper}
          aria-label="a dense table"
        >
          {newBanner ? (
            <CreateBanner
              IdGames={props.selectedGame}
              IdSport={props.IdSport.trim()}
              IdLeague={selectedIdLeague}
              GameDateTime={gameDateTime}
              HomeNumber={homeNumber}
              VisitorNumber={visitorNumber}
              onClose={handleCloseNewBanner}
              searchGameValues={props.searchGameValues}
              clearArray={props.ClearArrar}
            />
          ) : (
            ""
          )}
          {isModify ? (
            <GameModify
              IdGames={props.selectedGame}
              IdLinetype={props.IdLinetype}
              IdSport={props.IdSport.trim()}
              onClose={handleCloseModify}
              searchGameValues={props.searchGameValues}
              updateML={updateML}
              clearArray={props.ClearArrar}
              datesRow= {datesRow}
              resetDatesRow = {resetDatesRow}
            />
          ) : (
            ""
          )}
          {isEvent ? (
            <EventsPerLeagueList
              IdGames={props.selectedGame}
              IdLeague={selectedIdLeague}
              onClose={handleCloseEvent}
              clearArray={props.ClearArrar}
              searchGameValues={props.searchGameValues}
            />
          ) : (
            ""
          )}
          {isModifyBanner ? (
            <ModifyBanner
              IdGames={selectedIdGame}
              IdLinetype={props.IdLinetype}
              IdSport={props.IdSport.trim()}
              onClose={handleCloseBannerModify}
              searchGameValues={props.searchGameValues}
            />
          ) : (
            ""
          )}
          {isStatus ? (
            <GameStatus
              IdGames={props.selectedGame}
              IdLinetype={props.IdLinetype}
              IdSport={props.IdSport.trim()}
              rotation={props.selectedGame[0]}
              onClose={handleCloseStatus}
              searchGameValues={props.searchGameValues}
              clearArray={props.ClearArrar}
              IdGameTNT={props.IdGameTNT}
              datesRow= {datesRow}
              resetDatesRow={resetDatesRow}
              IdLeague={selectedIdLeague}
              LeagueName={selectedLeagueName}
            />
          ) : (
            ""
          )}

          {isDelete ? (
            <DeleteGame
              IdGames={props.selectedGame}
              clearArray={props.ClearArrar}
              searchGameValues={props.searchGameValues}
              onClose={handleDelete}
            />
          ) : (
            ""
          )}

          {isPeriod ? (
            <GamePeriods
              IdSport={props.IdSport.trim()}
              IdGames={props.selectedGame}
              clearArray={props.ClearArrar}
              onClose={handlePeriods}
              searchGameValues={props.searchGameValues}
            />
          ) : (
            ""
          )}

          {isSettings ? (
            <GameSettingsByLt
              IdGame={props.selectedGame}
              IdLinetype={props.IdLinetype}
              clearArray={props.ClearArrar}
              onClose={handleSettings}
              searchGameValues={props.searchGameValues}
            />
          ) : (
            ""
          )}

          {isCharting ? (
            <ChartingInfo
              IdGame={selectedIdGame}
              IdLinetype={props.IdLinetype}
              IdSport={props.IdSport.trim()}
              HomeTeam={homeTeam}
              VisitorTeam={visitorTeam}
              ActionType={0}
              Play={selectedPlay}
              Points={points}
              onClose={handleCloseCharting}
            />
          ) : (
            ""
          )}
          {isHidden ? (
            <HideGames
              IdGame={props.selectedGame}
              onClose={handleCloseHideGames}
              IdSport={props.IdSport.trim()}
            />
          ) : (
            ""
          )}

          {/* <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={classes.headerCell}>
                <strong>Date</strong>
              </TableCell>
              <TableCell className={classes.headerCell}>
                <strong>Rotation</strong>
              </TableCell>
              <TableCell className={classes.headerCell}>
                <strong>Match</strong>
              </TableCell>
             

              <TableCell className={classes.headerCell}>
                <strong>Spread</strong>
              </TableCell>

              <TableCell className={classes.headerCell}>
                <strong>Action</strong>
              </TableCell>
              <TableCell className={classes.headerCell}>
                <strong>Sum</strong>
              </TableCell>

              <TableCell className={classes.headerCell}>
                <strong>Totals</strong>
              </TableCell>

              <TableCell className={classes.headerCell}>
                <strong>Action</strong>
              </TableCell>
              <TableCell className={classes.headerCell}>
                <strong>Sum</strong>
              </TableCell>

              <TableCell className={classes.headerCell}>
                <strong>ML</strong>
              </TableCell>

              <TableCell className={classes.headerCell}>
                <strong>Action</strong>
              </TableCell>
              <TableCell className={classes.headerCell}>
                <strong>Sum</strong>
              </TableCell>

              <TableCell className={classes.headerCell}>
                <strong>Special</strong>
              </TableCell>
            </TableRow>
          </TableHead> */}
          {renderTableHead(props.IdSport.trim())}
          <TableBody>
            {props.data &&
              props.data
                .filter(
                  (e) =>
                    e.homeTeam?.toLowerCase().includes(
                      props.filterStr.toLowerCase()
                    ) ||
                    e.visitorTeam?.toLowerCase().includes(
                      props.filterStr.toLowerCase()
                    ) ||
                    e.homeNumber?.toString()
                      .toLowerCase()
                      .includes(props.filterStr.toLowerCase()) ||
                    e.visitorNumber?.toString().includes(
                      props.filterStr.toLowerCase()
                    ) ||
                    e.homeOdds?.toString().includes(
                      props.filterStr.toLowerCase()
                    ) ||
                    e.visitorOdds?.toString()
                      .toLowerCase()
                      .includes(props.filterStr.toLowerCase())
                )
                .slice(
                  currentPage * rowsPerPage,
                  currentPage * rowsPerPage + rowsPerPage
                )
                .map((row) => {
                  // Determina si se debe renderizar el contenido
                  // Determina si se debe renderizar el contenido
                  const gameDate = row.gameDateTime.split("T")[0];
                  const key = `${gameDate}-${row.leagueDescription}`;
                  const shouldRenderContent =
                    row.gameStat === "B" ||
                    previousRow === null ||
                    row.leagueDescription !== previousRow.leagueDescription 
                    || gameDate !== previousRow.gameDateTime.split("T")[0];
                    // || row.description !== previousRow.Description;

                  const isHidden = hiddenGames[key];
                  // Actualiza previousRow
                  previousRow = row;

                  const filteredData = props.data?.filter(
                    (e) =>
                      e.homeTeam?.toLowerCase().includes(props.filterStr.toLowerCase()) ||
                      e.visitorTeam?.toLowerCase().includes(props.filterStr.toLowerCase()) ||
                      e.homeNumber?.toString().toLowerCase().includes(props.filterStr.toLowerCase()) ||
                      e.visitorNumber?.toString().includes(props.filterStr.toLowerCase()) ||
                      e.homeOdds?.toString().includes(props.filterStr.toLowerCase()) ||
                      e.visitorOdds?.toString().toLowerCase().includes(props.filterStr.toLowerCase())
                  );
                  const rows = filteredData.filter(
                    (game) =>
                      game.leagueDescription === row.leagueDescription &&
                      game.gameDateTime.split("T")[0] === gameDate &&
                      game.gameStat !== "B"
                  );

                  return (
                    <React.Fragment key={row.idGame}>
                      {shouldRenderContent ? (
                        <TableRow>
                          <TableCell
                            colSpan="14"
                            className="schedule-banner classes.tableRow"
                          >
                            {/* <input type="checkbox" className="relative right-[7px] top-[2px]"  onChange={() => toggleVisibility(gameDate, row.leagueDescription)} checked={!!hiddenGames[key]}></input> */}
                            <input
                              type="checkbox"
                              className="relative right-[7px] top-[2px]"
                              onChange={() => toggleSelection(rows)}
                              checked={rows.every((r) =>
                                isSelected(props.IdSport.trim() !== "TNT" ? r.idGame : r.visitorOdds)
                              )}
                            />
                            <Time
                              value={row.gameDateTime}
                              format="DD/MM/YYYY"
                            />
                            {" " + row.leagueDescription}
                          </TableCell>
                        </TableRow>
                      ) : null}
                      {
                        isHidden ? null :
                        <>
                          {row.description !== '' && 
                          <TableRow className="border-b border-t border-black">
                            <TableCell
                              colSpan="14"
                              className={` ${" classes.tableRow !border-b !text-black !border-b-black !font-semibold"} `}
                              style={{
                              backgroundColor: windowsColorToHex(
                                                          row.gameStat !== "O" && row.gameColor
                                                            ? row.gameColor?.bkColor
                                                            : row.gameType?.bkColor
                                                        ),
                              color: windowsColorToHex(row.gameType?.fkColor),
                            }}
                              >
                              {row.description}
                            </TableCell>
                          </TableRow>
                          }
                          <TableRow
                            ref={(el) => (rowRefs.current[row.idGame] = el)}
                            style={{
                              backgroundColor: windowsColorToHex(
                                row.gameStat !== "O" && row.gameColor
                                  ? row.gameColor?.bkColor
                                  : row.gameType?.bkColor
                              ),
                              color: windowsColorToHex(
                                row.gameStat !== "O" && row.gameColor
                                  ? row.gameColor?.fkColor
                                  : row.gameType?.fkColor
                              ),
                              borderBottom: "1px solid lightgray", // Aquí agregas el borde
                            }}
                            className={`${
                              row.gameStat === "B"
                                ? "schedule-banner classes.tableRow"
                                : getStyle(row.gameStat, row.gameDateTime)
                            }${
                              isGameDateTimePassed(row.gameDateTime) ? " bg-blue-passed" : ""
                            } ${
                              row.idGame === props.lastChangedGamedID
                                ? "row-recent"
                                : ""
                            }
                            ${highlightRow === row.idGame ? "highlight" : ""}`}
                            key={row.idGame}
                            onClick={(event) =>
                              handleClickCheckEvent(
                                event,
                                row.idGame,
                                row.idLeague,
                                row.parentGame,
                                row.homeNumber,
                                row.visitorNumber,
                                row.visitorOdds,
                                row
                              )
                            }
                            checked={isSelected(row.idGame, row.visitorOdds)}
                          >
                            {row.gameStat !== "B" ? (
                              <>
                                <TableCell>
                                  <label>
                                    <StyledCheckbox
                                      checked={isSelected(
                                        row.idGame,
                                        row.visitorOdds
                                      )}
                                    />
                                    <Time
                                      value={row.gameDateTime}
                                      format="DD/MM/YY HH:mm"
                                    />
                                  </label>
                                </TableCell>
                                <TableCell>
                                  <span className="rotation-badge">
                                    {row.visitorNumber}
                                  </span>
                                  <br></br>
                                  <span className="rotation-badge">
                                    {row.homeNumber}
                                  </span>
                                </TableCell>
                              </>
                            ) : (
                              " "
                            )}
                            {row.gameStat !== "B" ? (
                              <TableCell>
                                {row.visitorTeam}
                                {props.IdSport.trim() === "MLB" ? (
                                  <span
                                    style={{
                                      fontSize: "9px",
                                      color: "dimgray",
                                    }}
                                  >
                                    {" " + row.visitorPitcher}
                                  </span>
                                ) : (
                                  ""
                                )}
                                <br></br>
                                {row.homeTeam}
                                {props.IdSport.trim() == "MLB" ? (
                                  <span
                                    style={{
                                      fontSize: "9px",
                                      color: "dimgray",
                                    }}
                                  >
                                    {" " + row.homePitcher}
                                  </span>
                                ) : (
                                  ""
                                )}
                                <br></br>
                                {props.IdSport.trim() == "SOC" ? "Draw " : ""}
                              </TableCell>
                            ) : (
                              <TableCell
                                colSpan="14"
                                className={`${
                                  row.gameStat === "B"
                                    ? " schedule-banner classes.tableRow"
                                    : "classes.tableRow"
                                }`}
                                component="th"
                                scope="row"
                              >
                                {row.visitorTeam} {row.homeTeam} {/*banner*/}
                              </TableCell>
                            )}
                            
                            {/* Aca es el render dínamico de las columnas */}
                            {
                              renderColumns(row, props.IdSport.trim())
                            }


                          {row.gameStat !== "B" && <TableCell className={classes.headerCell}>
                            {getShortValue(row.gameStat)}
                            <br></br>
                            {row.gameType?.short}
                          </TableCell>}
              
                          </TableRow>
                        </>
                      }
                    </React.Fragment>
                  );
                })}
          </TableBody>
        </Table>
        {props && props.data && (
          <div >
            <TablePagination
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={pageNumbers.length}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onChangePage={handleClick}
              onChangeRowsPerPage={handleChange}
            />
          </div>
        )}
        {
          lineHistoryModal && (
            <div className="modal-line">
              <div className="modal-line-card bg-white">
                 <div className="flex justify-between ">
                  <h3>Lines History:</h3>
                  <span onClick={()=> setLineHistoryModal(false)} className="font-normal text-sm text-gray-700 bg-gray-100 hover:bg-gray-200 cursor-pointer transition-all rounded-full w-6 h-6 flex items-center justify-center">x</span>
                 </div>
                 <div className="table-container">
                  <table className="odds-table">
                    <thead>
                      <tr>
                        <th>Time</th>
                        <th>{!isDraw ? rowSelected.visitorTeam : "Draw"}</th>
                        {
                          !isDraw && <th>{rowSelected.homeTeam}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {mergedRows.map((r, idx) => (
                        <tr key={idx}>
                          <td>{fmt(r.time)}</td>
                          <td>{r.visitor}</td>
                          {
                            !isDraw &&    <td>{r.home}</td>
                          }
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>

              </div>
            </div>
          )
        }
      </div>
    </React.Fragment>
  );
}
